import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const MainLogo = () => {
  const { t } = useTranslation();

  const custormList = [
    {
      imgurl: "//files.authing.co/authing-website/home-logo-cnpc-new.png",
      alt: `authing ${t("common.logo.中国石油")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-bosch.jpeg",
      alt: `authing bosch`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-toyota-red.svg",
      alt: `authing ${t("common.logo.丰田")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-logo-zhaoshang.svg",
      alt: `authing ${t("common.logo.招商银行")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-higer-new.png",
      alt: `authing ${t("common.logo.高等教育出版社")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-dongnan-new.png",
      alt: `authing ${t("common.logo.东南大学")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/logo-sichuan-university.png",
      alt: `authing ${t("common.logo.华西医院")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-logo-jcdecaux.png",
      alt: `authing ${t("common.logo.德高集团")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-dazhong-new.png",
      alt: `authing`,
    },

    {
      imgurl: "//files.authing.co/authing-website/home-logo-bentley.png",
      alt: `authing bentley`,
    },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-logo-pand-new.png",
    //   alt: `authing ${t("common.logo.盼达用车")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-cnpc.png",
    //   alt: `authing ${t("common.logo.中国石油")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-state.png",
    //   alt: `authing ${t("common.logo.国家电网")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-toyota.png",
    //   alt: `authing ${t("common.logo.丰田")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-bank.png",
    //   alt: `authing ${t("common.logo.招商银行")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-higer.png",
    //   alt: `authing ${t("common.logo.高等教育出版社")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-stack.png",
    //   alt: `authing ${t("common.logo.stackchat")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-chatopera.png",
    //   alt: `authing ${t("common.logo.chatopera")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-jcdecaux.png",
    //   alt: `authing ${t("common.logo.德高集团")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-pand.png",
    //   alt: `authing ${t("common.logo.盼达用车")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-banner-logo-lezhi.png",
    //   alt: `authing ${t("common.logo.乐智机器人")}`,
    // },
  ];
  return (
    <div className="main-logo">
      <div key="1" className="inner">
        <section className="partner-warp" style={{ marginBottom: 70 }}>
          <div className="partner">
            {custormList.map((brand) => {
              return (
                <div className="brand">
                  <img src={brand.imgurl} alt={brand.alt} />
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};
